export default "__VITE_ASSET__P_08sFL$__"